import styled from 'styled-components/macro'

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`
